import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('sisu');
export default logger;

//# sourceMappingURL=logger.js.map